// extracted by mini-css-extract-plugin
module.exports = {"container":"ChatbotButton_container__UZFrj","open":"ChatbotButton_open__xYiDO","button":"ChatbotButton_button__xefvH","app":"ChatbotButton_app__sCL0t"};